<template>
  <section id="container" class="main">
    <!-- visual start -->
    <section id="main-visual" class="main"><!-- 로그인 전 -->
      <div class="main-visual-con">
        <div class="grid--con">
          <div class="main-login-box">
            <div class="works-top-con">
              <h1 class="blind">아이오감</h1>
              <div class="works-top-form" v-if="!loginAt">
                <div class="tit-box">
                  <div class="f-left">LOGIN</div>
                  <div class="f-right">
                    <!--<a href="javascript:;" @click="btn_reqTmpMber()"><div class="img-com _bt-ic10"><span>아이콘</span></div> 임시계정안내</a>-->
                    <a href="javascript:;" @click="btn_joinClick()" style="padding-left:10px;">
                      <div class="img-com _bt-ic10"><span>아이콘</span></div>
                      회원가입</a>
                  </div>
                </div>
                <input type="text" ref="id" placeholder="아이디" v-model="loginInfo.id"/>
                <input type="password" ref="password" placeholder="패스워드" v-model="loginInfo.password"
                       @keyup.enter="btn_loginClick()"/>
                <button @click="btn_loginClick()"><span><img
                    src="../../../assets/i5gam/images/btn-main-login.png"/></span></button>
                <div class="tit-box">
                  <div class="f-left">
                    <input type="checkbox" id="chk01" v-model="saveId">
                    <label for="chk01" class="mg0"><span class="box"></span><span class="label-txt"
                                                                                  style="color:#000; font-size:14px;"><b>아이디 저장</b></span></label>
                  </div>
                  <div class="f-right">
                    <a href="javascript:;" @click="btn_findIdPw()" style="color:#000; font-size:14px;"><b>아이디·비밀번호
                      찾기</b></a>
                  </div>
                </div>
                <!-- <button @click="btn_srvcReqClick()"><span><img src="../../../assets/i5gam/images/img15.png"/></span></button> -->
                <button @click="btn_downLoadClick('manual')">
                  <span><img src="../../../assets/i5gam/images/btn-login-main-manual1.png" alt="아이오감 시작 매뉴얼"/></span>
                </button>
                <button class="mgl2"
                        @click="showVideoMenual('https://youtu.be/fa4vOBcqqEU')">
                  <span><img src="../../../assets/i5gam/images/btn-login-main-manual2.png" alt="동영상 시작 매뉴얼"/></span>
                </button>
                <button class="mgl2"
                        @click="btn_downLoadClick('ot')">
                  <span><img src="../../../assets/i5gam/images/btn-login-main-manual3.png" alt="오티자료 다운로드"/></span>
                </button>
              </div>
              <div class="works-top-form" v-if="loginAt">
                <div class="tit-box">
                  <div class="__right">
                    <a href="javascript:;" @click="btn_mypageClick()">
                      <div class="img-com _bt-ic10"><span>아이콘</span></div>
                      마이페이지</a>
                    <a class="mgl10" href="javascript:;" @click="btn_logoutClick()">
                      <div class="img-com _bt-ic10"><span>아이콘</span></div>
                      로그아웃</a>
                  </div>
                  <div class="mgt10 mgb10">{{ mberInfo.mberNm }}님</div>
                </div>
                <!--
                                <table>
                                    <colgroup>
                                        <col style="width:27%;" />
                                        <col style="width:*;" />
                                    </colgroup>
                                    <tbody>
                                    <tr>
                                        <th>휴대폰번호</th>
                                        <td>{{mberInfo.cttpc}}</td>
                                    </tr>
                                    <tr>
                                        <th>이메일</th>
                                        <td>{{mberInfo.email}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                                -->
                <button @click="btn_srvcStartClick()"><span><img
                    src="../../../assets/i5gam/images/btn-main-act.png"/></span></button>
                <button @click="btn_jikimSrvcStartClick()"
                        v-if="mberInfo.jkUseAt == 'Y'">
                  <span><img src="../../../assets/i5gam/images/btn_keeperexe.png"/></span>
                </button>
                <button @click="btn_srvcReqClick()"><span><img
                    src="../../../assets/i5gam/images/btn-main-rc.png"/></span></button>
                <button @click="btn_payClick()"><span><img src="../../../assets/i5gam/images/btn-main-pm.png"/></span>
                </button>
                <button @click="btn_downLoadClick('manual')">
                  <span><img src="../../../assets/i5gam/images/btn-login-main-manual1.png" alt="아이오감 시작 매뉴얼"/></span>
                </button>
                <button class="mgl2"
                        @click="showVideoMenual('https://youtu.be/fa4vOBcqqEU')">
                  <span><img src="../../../assets/i5gam/images/btn-login-main-manual2.png" alt="동영상 시작 매뉴얼"/></span>
                </button>
                <button class="mgl2"
                        @click="btn_downLoadClick('ot')">
                  <span><img src="../../../assets/i5gam/images/btn-login-main-manual3.png" alt="오티자료 다운로드"/></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- //visual start -->
    <!-- content start -->
    <div id="content">
      <div class="grid--con-sub">
        <div class="youtube-box">
          <div class="entry-title __center">
            <div class="img-com __icon27 mgr10"><span>youtube</span></div>
            동영상을 통해 아이오감 알아보기!
          </div>
          <div class="youtube-box-link">
            <div class="__link">
              <a href="javascript:;" @click="showVideoMenual('https://youtu.be/fa4vOBcqqEU')">
                <div class="img-com __icon28"><span>youtube</span></div>
                아이오감 통합매뉴얼<span>https://youtu.be/fa4vOBcqqEU</span></a>
              <a href="javascript:;" @click="showVideoMenual('https://youtu.be/dAlQtqBvtnE')">
                <div class="img-com __icon28"><span>youtube</span></div>
                교직원앱 – 보육인 활용방법<span>https://youtu.be/dAlQtqBvtnE</span></a>
            </div>
            <div class="entry-title">각각 업무별 사용법 살펴보기</div>
            <div class="__link">
              <!--a href="#" @click="showVideoMenual('https://youtu.be/4OjZe0NV7Ds')"><div class="img-com __icon28"><span>youtube</span></div> 원아태그등록하기<span>https://youtu.be/4OjZe0NV7Ds</span></a-->
              <a href="javascript:;" @click="showVideoMenual('https://youtu.be/5rWcjixOtDo')">
                <div class="img-com __icon28"><span>youtube</span></div>
                전자출결업무 - 보육통합전송 하기<br/>
                <span>https://youtu.be/5rWcjixOtDo</span>
              </a>

<!--              <a href="javascript:;" @click="showVideoMenual('https://youtu.be/Iyx5tcJMfWQ')">
                <div class="img-com __icon28"><span>youtube</span></div>
                반 원아 관리 - 추가, 퇴소하기<br/>
                <span>https://youtu.be/Iyx5tcJMfWQ</span>
              </a>-->

              <a href="javascript:;" @click="showVideoMenual('https://youtu.be/2BVwHE4u91o')">
                <div class="img-com __icon28"><span>youtube</span></div>
                교직원 - 초대, 등록, 퇴사하기<br/>
                <span>https://youtu.be/2BVwHE4u91o</span>
              </a>

              <a href="javascript:;" @click="showVideoMenual('https://youtu.be/z5SPfFKPaKk')">
                <div class="img-com __icon28"><span>youtube</span></div>
                신입원아 등록 및 퇴소등록하기<br/>
                <span>https://youtu.be/renbDQeGv1A</span>
              </a>
              <!--<a href="javascript:;" @click="showVideoMenual('https://youtu.be/z5SPfFKPaKk')"><div class="img-com __icon28"><span>youtube</span></div> 알림장 권한 설정하기<br /><span>https://youtu.be/z5SPfFKPaKk</span></a>-->

              <a href="javascript:;" @click="showVideoMenual('https://youtu.be/4OjZe0NV7Ds')">
                <div class="img-com __icon28"><span>youtube</span></div>
                태그등록<br/>
                <span>https://youtu.be/4OjZe0NV7Ds</span>
              </a>

              <a href="javascript:;" @click="showVideoMenual('https://youtu.be/AoR3ykZBHrQ')">
                <div class="img-com __icon28"><span>youtube</span></div>
                태그 추가구매<br/>
                <span>https://youtu.be/AoR3ykZBHrQ</span>
              </a>

              <a href="javascript:;" @click="showVideoMenual('https://youtu.be/QiNX1tQ2kcc')">
                <div class="img-com __icon28"><span>youtube</span></div>
                태그확인, 초기화, 분실처리 방법<br/>
                <span>https://youtu.be/QiNX1tQ2kcc</span>
              </a>
              <!--<a href="javascript:;" @click="showVideoMenual('https://youtu.be/OydXgqlFHgU')"><div class="img-com __icon28"><span>youtube</span></div> 태그 초기화 하기<br /><span>https://youtu.be/OydXgqlFHgU</span></a>-->

              <a href="javascript:;" @click="showVideoMenual('https://youtu.be/QiNX1tQ2kcc')">
                <div class="img-com __icon28"><span>youtube</span></div>
                태그 일련번호는 왜 있는거죠?<br/>
                <span>https://youtu.be/QiNX1tQ2kcc</span>
              </a>

              <a href="javascript:;" @click="showVideoMenual('https://youtu.be/BgEpTAs2e8M')">
                <div class="img-com __icon28"><span>youtube</span></div>
                이용현황 확정과 출석부 전송<br/>
                <span>https://youtu.be/BgEpTAs2e8M</span>
              </a>
              <!-- <span href="#" @click="showVideoMenual('https://youtu.be/G2mUMDgghDI')"><div class="img-com __icon28"><span>youtube</span></div> 스마트폰 태깅시 인식이 잘되는 위치는?<br /><span>https://youtu.be/G2mUMDgghDI</span></a> -->
            </div>
          </div>
        </div>
      </div>
      <div class="grid--con-sub mgt40">
        <!-- tab -->
        <div class="tab-i5gam">
          <ul class="tabmenu">
            <li :class="selTabIdx == 0?'current':''" @click="tabClick(0)"><a href="javascript:;">아이오감 출결 동작방식</a></li>
            <li :class="selTabIdx == 1?'current':''" @click="tabClick(1)"><a href="javascript:;">아이오감 시스템 구성</a></li>
            <li :class="selTabIdx == 2?'current':''" @click="tabClick(2)"><a href="javascript:;">아이오감 특장점</a></li>
            <li :class="selTabIdx == 3?'current':''" @click="tabClick(3)"><a href="javascript:;">모바일앱 보기(교직원/부모)</a>
            </li>
            <li :class="selTabIdx == 4?'current':''" @click="tabClick(4)"><a href="javascript:;">아이오감 설정하기</a></li>
            <li :class="selTabIdx == 5?'current':''" @click="tabClick(5)"><a href="javascript:;">함께하는 기업</a></li>
          </ul>
          <div class="tab-container">
            <div class="tab-content" v-show="selTabIdx == 0">
              <h1 class="tit-type3">아이오감 출결 동작방식</h1>
              <img src="../../../assets/i5gam/images/img-i5gam-tab1.png"/>
            </div>
            <div class="tab-content" v-show="selTabIdx == 1">
              <h1 class="tit-type3">아이오감 시스템 구성</h1>
              <img src="../../../assets/i5gam/images/img-i5gam-tab2.png"/>
            </div>
            <div class="tab-content" v-show="selTabIdx == 2">
              <h1 class="tit-type3">아이오감 특장점</h1>
              <div class="font-s32 __center">"서비스 시작부터 끝까지 책임지겠습니다!"</div>
              <img src="../../../assets/i5gam/images/img-i5gam-tab3.png"/>
            </div>
            <div class="tab-content" v-show="selTabIdx == 3">
              <h1 class="tit-type3">모바일앱 보기(교직원/부모)</h1>
              <div class="dp-tb">
                <div class="dp-td" style="width:50%;">
                  <div class="i5gam-con-mobileapp" style="border-right:1px solid #e9e9e9;">
                    <div class="entry-title">교직원용 <span class="pc02">홈페이지/모바일앱</span></div>
                    <img src="../../../assets/i5gam/images/img-i5gam-tab4-1.png"/>
                    <ul class="txt-type2-1 depth2 mgt25" style="margin-left: 30px;">
                      <li>회원가입은 홈페이지에서만 가능</li>
                      <li>보육교직원은 홈페이지와 모바일앱 모두 가능</li>
                      <li>전자출결업무, 태그등록, 알림장, 투약의뢰서, 앨범 기능제공</li>
                      <li>시작설정 : 부모초대, 교직원 아이디 연결</li>
                      <li>보육통합시스템에 출결 정보 전송</li>
                      <li>프로그램 권한관리</li>
                      <li>원아태그 등록</li>
                      <li>공지사항 작성</li>
                    </ul>
                  </div>
                </div>
                <div class="dp-td" style="width:50%;">
                  <div class="i5gam-con-mobileapp">
                    <div class="entry-title">학부모용 <span class="pc02">모바일앱</span></div>
                    <img src="../../../assets/i5gam/images/img-i5gam-tab4-2.png"/>
                    <ul class="txt-type2-1 depth2 mgt25" style="margin-left: 150px;">
                      <li>스마트 알림장 이용
                        <ul class="txt-type2-2">
                          <li>앨범, 투약의뢰, 귀가요청, 전자문서 제공</li>
                        </ul>
                      </li>
                      <li>원아 태그등록</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-content" v-show="selTabIdx == 4">
              <h1 class="tit-type3">아이오감 설정하기</h1>
              <ul class="i5gam-con-m-set">
                <li>
                  <div class="__m-set-con">
                    <h2 class="tit-type4">회원가입</h2>
                    <button @click="showVideoMenual('https://youtu.be/OlGBx5DIo_c')"><span><img
                        src="../../../assets/i5gam/images/btn-video.png"/></span></button>
                  </div>
                  <div class="__m-set-con">
                    <div class="__set-turn">
                      <div class="__set-turn-in">
                        <div class="__txt-box">
                          <div class="__txt-box-in">
                            <div class="__num"><span>01</span></div>
                            <div class="__txt">가입하기</div>
                          </div>
                        </div>
                      </div>
                      <div class="__set-turn-in">
                        <div class="__txt-box">
                          <div class="__txt-box-in">
                            <div class="__num"><span>02</span></div>
                            <div class="__txt">원정보 / 결제정보<br/>등록</div>
                          </div>
                        </div>
                      </div>
                      <div class="__set-turn-in">
                        <div class="__txt-box">
                          <div class="__txt-box-in">
                            <div class="__num"><span>03</span></div>
                            <div class="__txt">아동정보, 교사정보<br/>등록</div>
                          </div>
                        </div>
                      </div>
                      <div class="__set-turn-in last">
                        <div class="__txt-box">
                          <div class="__txt-box-in">
                            <div class="__num"><span>04</span></div>
                            <div class="__txt">반 아동정보 설정</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="__m-set-con">
                    <h2 class="tit-type4">환경설정</h2>
                    <button @click="showVideoMenual('https://youtu.be/bcC3bjL-0MY')"><span><img
                        src="../../../assets/i5gam/images/btn-video.png"/></span></button>
                  </div>
                  <div class="__m-set-con">
                    <div class="__set-turn">
                      <div class="__set-turn-in">
                        <div class="__txt-box">
                          <div class="__txt-box-in">
                            <div class="__num"><span>01</span></div>
                            <div class="__txt">교사 회원가입</div>
                          </div>
                        </div>
                      </div>
                      <div class="__set-turn-in">
                        <div class="__txt-box">
                          <div class="__txt-box-in">
                            <div class="__num"><span>02</span></div>
                            <div class="__txt">부모초대 / 로그인</div>
                          </div>
                        </div>
                      </div>
                      <div class="__set-turn-in last">
                        <div class="__txt-box">
                          <div class="__txt-box-in">
                            <div class="__num"><span>03</span></div>
                            <div class="__txt">교직원 아이디연결 /<br/>권한부여</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="__m-set-con">
                    <h2 class="tit-type4">사용하기</h2>
                    <button @click="showVideoMenual('https://youtu.be/iKorYm7YYUk')"><span><img
                        src="../../../assets/i5gam/images/btn-video.png"/></span></button>
                  </div>
                  <div class="__m-set-con">
                    <div class="__set-turn">
                      <div class="__set-turn-in">
                        <div class="__txt-box">
                          <div class="__txt-box-in">
                            <div class="__num"><span>01</span></div>
                            <div class="__txt">등하원 현황보기<br/>PC / 모바일앱</div>
                          </div>
                        </div>
                      </div>
                      <div class="__set-turn-in">
                        <div class="__txt-box">
                          <div class="__txt-box-in">
                            <div class="__num"><span>02</span></div>
                            <div class="__txt">태그 등록</div>
                          </div>
                        </div>
                      </div>
                      <div class="__set-turn-in last">
                        <div class="__txt-box">
                          <div class="__txt-box-in">
                            <div class="__num"><span>03</span></div>
                            <div class="__txt">출결정보 전송하기</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="__m-set-con">
                    <h2 class="tit-type4">교직원 앱 활용방법</h2>
                    <button @click="showVideoMenual('https://youtu.be/dAlQtqBvtnE')"><span><img
                        src="../../../assets/i5gam/images/btn-video.png"/></span></button>
                  </div>
                  <div class="__m-set-con">
                    <div class="__set-turn">
                      <div class="__set-turn-in">
                        <div class="__txt-box">
                          <div class="__txt-box-in">
                            <div class="__num"><span>01</span></div>
                            <div class="__txt">교직원 앱<br/>"보육인" 설치하기</div>
                          </div>
                        </div>
                      </div>
                      <div class="__set-turn-in">
                        <div class="__txt-box">
                          <div class="__txt-box-in">
                            <div class="__num"><span>02</span></div>
                            <div class="__txt">태그 등록</div>
                          </div>
                        </div>
                      </div>
                      <div class="__set-turn-in">
                        <div class="__txt-box">
                          <div class="__txt-box-in">
                            <div class="__num"><span>03</span></div>
                            <div class="__txt">전자출결 업무<br/>알아보기</div>
                          </div>
                        </div>
                      </div>
                      <div class="__set-turn-in last">
                        <div class="__txt-box">
                          <div class="__txt-box-in">
                            <div class="__num"><span>04</span></div>
                            <div class="__txt">스마트 알림장<br/>사용하기</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="tab-content" v-show="selTabIdx == 5">
              <div class="i5gam-con-grid-both mgt60">
                <h1 class="tit-type3 f-left">함께하는 기업</h1>
                <div class="f-right">
                  <h2 class="tit-type4">한국 비영리 회계프로그램 사업자 협동조합 <span class="pc02">(한.비.협.)</span></h2>
                  <ul class="__ct-list">
                    <li>
                      <div class="box-type01">
                        <div class="dp-tr">
                          <div class="__company"><img src="../../../assets/i5gam/images/img-i5gam-ct-list1.png"/></div>
                        </div>
                        <div class="__call">1566-2703</div>
                      </div>
                    </li>
                    <li>
                      <div class="box-type01">
                        <div class="dp-tr">
                          <div class="__company"><img src="../../../assets/i5gam/images/img-i5gam-ct-list2.png"/></div>
                        </div>
                        <div class="__call">02-984-0000</div>
                      </div>
                    </li>
                    <li>
                      <div class="box-type01">
                        <div class="dp-tr">
                          <div class="__company"><img src="../../../assets/i5gam/images/img-i5gam-ct-list3.png"/></div>
                        </div>
                        <div class="__call">070-5056-0631</div>
                      </div>
                    </li>
                    <li>
                      <div class="box-type01">
                        <div class="dp-tr">
                          <div class="__company"><img src="../../../assets/i5gam/images/img-i5gam-ct-list4.png"/></div>
                        </div>
                        <div class="__call">1661-3369</div>
                      </div>
                    </li>
                    <li>
                      <div class="box-type01">
                        <div class="dp-tr">
                          <div class="__company"><img src="../../../assets/i5gam/images/img-i5gam-ct-list5.png"/></div>
                        </div>
                        <div class="__call">1588-4202</div>
                      </div>
                    </li>
                    <li>
                      <div class="box-type01">
                        <div class="dp-tr">
                          <div class="__company"><img src="../../../assets/i5gam/images/img-i5gam-ct-list6.png"/></div>
                        </div>
                        <div class="__call">053-986-0905</div>
                      </div>
                    </li>
                    <li>
                      <div class="box-type01">
                        <div class="dp-tr">
                          <div class="__company"><img src="../../../assets/i5gam/images/img-i5gam-ct-list22.png"/></div>
                        </div>
                        <div class="__call">1600-0330</div>
                      </div>
                    </li>
                  </ul>
                  <h2 class="tit-type4">기타</h2>
                  <ul class="__ct-list">
                    <li>
                      <div class="box-type01">
                        <div class="dp-tr">
                          <div class="__company">인텍</div>
                        </div>
                        <div class="__call">032-224-4309 / 010-5338-4309</div>
                      </div>
                    </li>
                    <!-- <li>
                      <div class="box-type01">
                        <div class="dp-tr">
                          <div class="__company">그물정보시스템</div>
                        </div>
                        <div class="__call">010-6201-0805</div>
                      </div>
                    </li> -->
                    <li>
                      <div class="box-type01">
                        <div class="dp-tr">
                          <div class="__company">공감</div>
                        </div>
                        <div class="__call">010-8950-6363</div>
                      </div>
                    </li>
                    <li>
                      <div class="box-type01">
                        <div class="dp-tr">
                          <div class="__company">뷰 공감</div>
                        </div>
                        <div class="__call">010-9041-3392</div>
                      </div>
                    </li>
                    <li>
                      <div class="box-type01">
                        <div class="dp-tr">
                          <div class="__company">키움</div>
                        </div>
                        <div class="__call">010-5178-0979</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- //tab -->
        <div class="video-use-user">
          <div class="video-use-user-con">
            <iframe width="720" height="404" src="https://www.youtube.com/embed/BiBPnYz3xCg?rel=0" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'index',
  data: function () {
    return {
      loginInfo: {
        id: '',
        password: ''
      },
      saveId: false,
      srvcCd: 'SBIW02',
      selTabIdx: 0,
      tagOrderPayList: null,
    }
  },
  computed: {
    mberInfo: function () {
      return this.$store.getters.getMberInfo;
    },
    dayInfo: function () {
      return this.$store.getters.getDayInfo;
    },
    loginAt: function () {
      return this.$store.getters.getLoginAt;
    },
  },
  methods: {
    init: function () {
      const cookieId = this.getCookie('loginId');
      if (cookieId != null) {
        this.loginInfo.id = cookieId;
        this.saveId = true;
      }

      /* 기획부 요청 팝업 부분 */
      //if(this.getCookie('gulummaShop') != 'done') this.openGulummaShopPopup();
      //if(this.getCookie('gulummaShop2') != 'done') this.openGulummaShopPopup2();
      //if(this.getCookie('brother') != 'done') this.openFreeEduPopup();

      this.$store.dispatch('getLoginSession').then(function (loginInfo) {
        //팝업 체크
        this.chkPopupUseAt();

        if (loginInfo.procCode == '001') {
          this.$store.commit('setMberInfo', loginInfo.memberInfo);

          if (loginInfo.tagOrderPayList.length != 0) {
            this.tagOrderPayList = loginInfo.tagOrderPayList;
          }

          /*if (loginInfo.cardRegAt == 'N') {
            this.openCardRegPopup();
          }*/

          if (typeof this.$route.params.callBackSe != 'undefined') {
            this.btn_srvcReqClick();
          }
        } else {
          this.$store.commit('clearLoginInfo');
        }
      }.bind(this)).catch(function (e) {
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    btn_loginClick: function () {
      this.loginInfo.id = this.loginInfo.id.replaceAll(' ', '');
      if (this.loginInfo.id == '') {
        this.$toasted.show('아이디를 입력해주세요.');
        this.$refs.id.focus();
        return false;
      }

      this.loginInfo.password = this.loginInfo.password.replaceAll(' ', '');
      if (this.loginInfo.password == '') {
        this.$toasted.show('비밀번호를 입력해주세요.');
        this.$refs.password.focus();
        return false;
      }

      this.$store.dispatch('loginProc', this.loginInfo).then(function (loginProcInfo) {
        const code = loginProcInfo.procCode;
        const passAt = loginProcInfo.passAt;
        const mberInfo = loginProcInfo.mberInfo;

        if (code == '001') {
          this.setSaveId();  //아이디저장

          this.$store.commit('setMberInfo', loginProcInfo.memberInfo);
          if (loginProcInfo.tagOrderPayList.length > 0) {
            this.tagOrderPayList = loginProcInfo.tagOrderPayList;
          }

          /*if (loginProcInfo.cardRegAt == 'N') {
            this.openCardRegPopup();
          }*/

          this.loginInfo.id = '';
          this.loginInfo.password = '';
          if(passAt == 'CHNG') this.passwdChngPopup(mberInfo);
        } else if (code == '002') {    //약관 동의 안된 경우
          this.$router.push({name: 'views.i5gam.member.join'},);
        } else if (code == '003') {    //아이오감 임시아이디로 로그인한 경우
          alert('임시아이디로 로그인한 경우 회원가입을 진행해주셔야합니다.');
          this.$router.push({
            name: 'views.i5gam.member.join',
            params: {joinCours: loginProcInfo.memberInfo.joinCours, mberNo: loginProcInfo.memberInfo.mberNo}
          });
          this.$store.dispatch('logoutProc');
        } else if (code == '999') {
          this.$toasted.show('아이디 또는 비밀번호를 잘못 입력하셨습니다.');
          this.loginInfo.password = '';
        }
      }.bind(this)).catch(function (e) {
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    passwdChngPopup: function (mberInfo){
        let popupInfo = {
          se: 'modal',
          id: 'passwdChngPopup',
          wid: '650',
          hei: '',
          tit: '비밀번호 변경',
          draggableAt: false,
          param: {
            mberInfo: mberInfo
          }
        };

      this.$store.commit('openPopup', popupInfo);
    },
    setSaveId: function () {
      if (this.saveId == true) {
        this.setCookie("loginId", this.loginInfo.id, 30);
      } else {
        this.setCookie("loginId", '', -1);
      }
    },
    setCookie: function (name, value, days) {
      let todayDate = new Date();
      todayDate.setDate(todayDate.getDate() + days);
      document.cookie = name + "=" + escape(value) + "; path=/; expires=" + todayDate.toGMTString() + ";"
    },
    getCookie: function (Name) {
      let search = Name + "=";

      if (document.cookie.length > 0) { // if there are any cookies
        let offset = document.cookie.indexOf(search);
        if (offset != -1) { // if cookie exists
          offset += search.length; // set index of beginning of value
          let end = document.cookie.indexOf(";", offset); // set index of end of cookie value
          if (end == -1)
            end = document.cookie.length;
          return unescape(document.cookie.substring(offset, end));
        }
      }
    },
    btn_findIdPw: function () {
      this.$router.push({name: 'views.i5gam.member.findIdPw'});
    },
    btn_mypageClick: function () {
      this.$router.push({name: 'views.i5gam.member.myPage'});
    },
    btn_payClick: function () {
      this.$router.push({name: 'views.i5gam.member.myPage', params: {tagOrderPayList: this.tagOrderPayList}});
    },
    btn_srvcReqClick: function () {
      if (!this.loginAt) {
        alert('로그인이 필요합니다.');
        this.$refs.id.focus();
        return false;
      }

      const _this = this;
      this.searchI5gamSrvcReqList().then(function (reqSttusList) {
        let popupInfo = {};

        if (reqSttusList == null) {  //서비스 신청
          popupInfo = {
            se: 'modal',
            id: 'srvcReqPopup',
            wid: '1200',
            hei: '',
            tit: '서비스 신청',
            draggableAt: false,
            param: null
          };
        } else {    //아이오감 임시 아이디 서비스 신청
          popupInfo = {
            se: 'modal',
            id: 'srvcTmpReqPopup',
            wid: '1200',
            hei: '',
            tit: '서비스 신청',
            draggableAt: false,
            param: reqSttusList
          };
        }

        _this.$store.commit('openPopup', popupInfo);
      });
    },
    btn_reqTmpMber: function () {
      const popupInfo = {
        se: 'modal',
        id: 'tmpMberPopup',
        wid: '700',
        hei: '',
        tit: '임시계정 요청 안내',
        draggableAt: true,
        param: null
      };

      this.$store.commit('openPopup', popupInfo);
    },
    btn_downLoadClick: function (downloadSe) {
      //const url = '/i5gam/i5gamIndexDownLoad.act';

      const _this = this;
      let fileNm = '';
      let orgNm = '';
      let downUrl = '';

      if (downloadSe == 'cntrct') {   //계약서
        fileNm = '20200116123916999.pdf';
        orgNm = '걸음마 아이오감 서비스 표준 계약서.pdf';
        downUrl = '/fileApi/down/dst/3D636E388756E25637C76B5AB4A436755D852DDA538743B343A6045307585048476A631515B9F48D1456F812EF36597483677B24A87458C653F65459534B6B3B50D4';
      } else if (downloadSe == 'manual') {   //매뉴얼
        fileNm = '20200203112913999.pptx';
        orgNm = '아이오감매뉴얼_통합_사용자_매뉴얼_v0.95_음성수정.pptx';
        downUrl = '/fileApi/down/dst/AC7EB738357DE87A5B05B44B508DB86547C7B7958658C61553094A636634471F983EA35BB645F446C444426676F566A1364A0712783B556D28C7D56373383164A54535';
      } else if (downloadSe == 'ot') {	//ot자료
        fileNm = '20200219183013999.pptx';
        orgNm = '『걸음마 아이오감』 알림장 _부모OT자료.pptx';
        downUrl = '/fileApi/down/dst/2CF785475456D3641CB55687518D734E58DB31D556626F46545A1F0CB3A338B38F572494B6A95668ABCA88C661744B46073585B47674676543502A4E37395353696F43';
      }

      let fileInfo = {fileNm: fileNm, orgNm: orgNm, downUrl: downUrl};

      _this.$onbiLib.getAuthKey().then(function (authKey) {
        _this.$onbiLib.setCdnFileDownLoadUrl(fileInfo, encodeURIComponent(authKey));
      });

      /*const params = 'fileNm=' + fileNm + '&orgNm=' + orgNm;
      this.$onbiLib.setFileDownLoadUrl(url, params);*/
    },
    searchI5gamSrvcReqList: function () {
      const _this = this;
      return new Promise(function (resolve, reject) {
        _this.axios.post('/i5gam/srvc/searchI5gamSrvcReqList.act', {
          mberNo: _this.mberInfo.mberNo,
        }).then(function (response) {
          resolve(response.data.reqSttusList);
        }.bind(this)).catch(function (e) {
          reject(e);
        });
      })
    },
    btn_jikimSrvcStartClick: function () {
      let url = '';

      if (window.location.hostname.indexOf('localhost') > -1) {
        url='http://localhost:8981'
      }

      window.open(url + "/keeper/frontend/web/index.html?mberNo=" + this.mberInfo.mberNo, 'keeper');
    },
    btn_srvcStartClick: function () {
      /* const popupInfo = {
        se:'modal',
        id:'indexNoticePopup',
        wid:'500',
        hei:'',
        tit:'걸음마 아이오감 공지',
        draggableAt:false,
      };

      this.$store.commit('openPopup',popupInfo); */

      const _this = this;

      if (this.loginAt) {
        this.axios.post('/i5gam/srvc/searchMberSrvcFcltList.act', {
          mberNo: this.mberInfo.mberNo,
          srvcCd: this.srvcCd
        }).then(function (response) {
          const mberSrvcFcltList = response.data.mberSrvcFcltList;

          //로그인 시 중지인 원은 목록에서 제외(2021.02.08 추가)
          const fcltListFilter = mberSrvcFcltList.filter(function(info){
              return info.svcSttus == 'APR';
          });

          if (fcltListFilter != null && fcltListFilter.length > 0) {
            if (fcltListFilter.length == 1) {
              const fcltcd = fcltListFilter[0].fcltcd;
              this.remoteLoginProc(fcltcd, this.srvcCd);
            } else {
              const popupInfo = {
                se: 'modal',
                id: 'selMberSrvcFcltPopup',
                wid: '500',
                hei: '326',
                tit: '아이오감 실행하기',
                draggableAt: false,
                param: {
                  mberSrvcFcltList: fcltListFilter,
                  srvcCd: this.srvcCd,
                  remoteLoginProcFunc: this.remoteLoginProc
                }
              };

              this.$store.commit('openPopup', popupInfo);
            }
          } else {
            this.$toasted.show('서비스 신청된 원이 없습니다.\n서비스신청을 먼저 해주십시오.');
            this.btn_srvcReqClick();
          }
        }.bind(this)).catch(function (e) {
          console.log(e);
          _this.$toasted.show(_this.$onbiLib.msg.err.system);
        });
      } else {
        this.$toasted.show('로그인이 필요합니다.');
      }
    },
    remoteLoginProc: function (fcltcd, srvcCd) {
      var param = "?fcltcd=" + fcltcd + "&mberNo=" + this.mberInfo.mberNo + "&srvcCd=" + srvcCd;
      window.open("/portal/main/remoteLogin.on" + param, 'bo6in' + srvcCd);
    },
    btn_logoutClick: function () {
      const cookieId = this.getCookie('loginId'); //아이디 저장되어있으면 가져오기
      if (cookieId != null) {
        this.loginInfo.id = cookieId;
        this.saveId = true;
      }
      this.$store.dispatch('logoutProc');

    },
    btn_joinClick: function () {
      this.$router.push({name: 'views.i5gam.member.join'});
    },
    tabClick: function (idx) {
      this.selTabIdx = idx;
    },
    showVideoMenual: function (url) {
      window.open(url);
    },
    chkPopupExist: function () {
      for (let i = 1; i < 4; i++) {
        let popupImg = new Image();
        popupImg.src = '/images/i5gam/popup/popupImg' + i + '.png?de=' + this.dayInfo.ymd;
        const _this = this;

        popupImg.onload = function () {
          const popupInfo = {
            se: 'modal',
            id: 'fcltCloseExtendPopup',
            wid: '710',
            hei: '',
            tit: '아이오감 공지',
            draggableAt: true,
          };

          _this.$store.commit('openPopup', popupInfo);
        }
      }
    },
    chkPopupUseAt: function () {
      const _this = this;
      this.axios.post('/i5gam/main/chkPopupUseAt.act', {}).then(function (response) {
        const popupInfo = response.data.popupInfo;
        for (let i = 1; i < 4; i++) {
          if (popupInfo[i] == 'Y') {
            const popupInfo = {
              se: 'modal',
              id: 'popup' + i,
              //id:'fcltCloseExtendPopup',
              wid: '700',
              hei: '',
              tit: '아이오감 공지',
              draggableAt: true,
            };

            _this.$store.commit('openPopup', popupInfo);
          }
        }
      }.bind(this)).catch(function (e) {
        console.log(e);
        _this.$toasted.show(_this.$onbiLib.msg.err.system);
      });
    },
    /*openCardRegPopup: function () {
      const popupInfo = {
        se: 'modal',
        id: 'startSetupInfoPopup',
        wid: '700',
        hei: '',
        tit: 'CMS 자동출금 결제 신청 안내',
        draggableAt: true,
      };

      this.$store.commit('openPopup', popupInfo);
    },*/
    openGulummaShopPopup: function (){
      const popupInfo = {
        se: 'modal',
        id: 'gulummaShopPopup',
        wid: '450',
        hei: '',
        tit: '걸음마 쇼핑몰',
        draggableAt: true,
      };

      this.$store.commit('openPopup', popupInfo);
    },
    openGulummaShopPopup2: function (){
      const popupInfo = {
        se: 'modal',
        id: 'gulummaShopPopup2',
        wid: '450',
        hei: '',
        left : '1180',
        tit: '걸음마 쇼핑몰',
        draggableAt: true,
      };

      this.$store.commit('openPopup', popupInfo);
    },
    openFreeEduPopup: function (){
      const popupInfo = {
        se: 'modal',
        id: 'freeEduPopup',
        wid: '600',
        hei: '',
        tit: '통합운영 안내 공지',
        draggableAt: true,
      };

      this.$store.commit('openPopup', popupInfo);
    }
  },
  mounted: function () {
    this.init();
  }
}
</script>

<style scoped>

</style>
